import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLong = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	stroke: "none",
	viewBox: "0 0 28 28",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m15.67 8.23-1.84 1.39 2.399 3.2h-8.229v2.35h8.229l-2.399 3.21 1.84 1.391 4.33-5.771z",
		transform: "matrix(1.9 0 0 1.9 -12.35 -12.35)"
	})
});
export default SvgArrowLong;
